export const PrettifiedJson = ({data}) => {
   return (
      <pre style={{whiteSpace: 'pre-wrap',lineBreak: 'anywhere'}}>{JSON.stringify(data, null, 2)}</pre>
   );
};